/*
 * @Author: 和子昭
 * @Date: 2021-01-13 16:01:32
 */
import Http from "./../http";
import md5 from 'js-md5';

export default {
  // 收藏
  cllect(urlParams, params, callback) {
    Http.post("/kqChildcare/getCollect", urlParams, params, res => {
      callback(res);
    },null,'lucky')
  },
  // 音频列表
  getListData(urlParams, params, callback) {
    Http.post("/parentingAudio/findAudioList", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  // 音频详情
  getAudioDetail(urlParams, params, callback) {
    Http.post("/parentingAudio/findAudio", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  // 收听
  addPlay(urlParams, params, callback) {
    Http.post("/parentingAudio/addPlay", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  // 点赞
  getLike(urlParams, params, callback) {
    Http.post("/parentingAudio/addLike", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  //收藏
  getCllect(urlParams, params, callback) {
    Http.post("/parentingAudio/addCollect", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  //分享
  shareLink(urlParams, params, callback) {
    Http.post("/parentingAudio/addShare", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  // 取消点赞
  cancelLike(urlParams, params, callback) {
    Http.post("/parentingAudio/cancelLike", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  },
  //取消收藏
  cancelCllect(urlParams, params, callback) {
    Http.post("/parentingAudio/cancelCollect", urlParams, params, res => {
      callback(res);
    }, null, 'lucky')
  }
}